<template><div><h1>VUX 打包体积过大</h1>
<p>一般是以下原因导致的：</p>
<h2>import 语法使用问题</h2>
<p>在 <code>vux-loader@1.0.61</code> 以下版本，如果你在 <code>import</code> 和 <code>{</code> 之前没有空格，将不会被解析成按需引入的，比如：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>{Group, Cell} <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>如果是这一情况，纠正或者升级到 vux-loader &gt;= 1.0.61 可解决。</p>
<div class="tip">
<p>建议开启 <code>eslint</code> 来避免这一情况，即使 <code>vux-loader</code> 支持，更严格的编码规范利于开发维护。</p>
</div>
<h2>没有正确配置 vux-loader</h2>
<p>参照文档配置或者使用 <code>airyland/vux2</code> 模板。</p>
<h2>不标准的写法</h2>
<p>vux-loader 基于代码文本替换实现按需引入，可能有部分奇怪的写法导致不能正确解析。可以建个 repo 联系作者解决。</p>
<p>同时强烈推荐开启 eslint 保证编码质量。</p>
<h2>注释里有 import 语句</h2>
<p>在 <code>vux-loader@1.0.67</code> 以下版本，如果存在单行注释里有从 VUX 引入组件会导致出现问题。请升级到最新。</p>
</div></template><script>
export default {
  head: {"title":"VUX 打包体积过大 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vux-build-issue-48.vue?699b3926